module.exports = __webpack_public_path__ + "media/images/favicon-539efa2e02c37f0e4a3844ba5597b7fa.png";